/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Lap_PrevInputs */

const en_ui_lap_prev = /** @type {(inputs: Ui_Lap_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous lap`)
};

const de_ui_lap_prev = /** @type {(inputs: Ui_Lap_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Runde`)
};

/**
* | output |
* | --- |
* | "Previous lap" |
*
* @param {Ui_Lap_PrevInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_lap_prev = /** @type {((inputs?: Ui_Lap_PrevInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Lap_PrevInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_lap_prev(inputs)
	return de_ui_lap_prev(inputs)
});